__turbopack_context__.v({
  "responsive-align": "styles-module__wsRlCq__responsive-align",
});
